import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { DefaultAddressField } from 'shared/ui/AddressFields';

import { DELIVERY_FORM_FIELDS } from 'features/DeliveryForm/constants';

type Props = {
  name: string;
  error: string;
  onSelect: (v: string) => void;
};

export const ControlledAddress = ({ name, error, onSelect }: Props) => {
  const { control, setError, clearErrors } = useFormContext();
  const [errorAddress, setErrorAddress] = useState('');

  const onSelectAddress = (newAddress: string) => {
    if (newAddress) {
      onSelect(newAddress);
    }
  };

  const setCustomError = (err: string) => {
    if (err) {
      setErrorAddress(err);
      setError(DELIVERY_FORM_FIELDS.ADDRESS, { message: err });
    } else {
      setErrorAddress('');
      clearErrors(DELIVERY_FORM_FIELDS.ADDRESS);
    }
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <DefaultAddressField
          onSelectAddress={onSelectAddress}
          placeholder="Адрес"
          setErrorAddress={setCustomError}
          meetingError={errorAddress || error}
          address={field.value}
          setAddress={field.onChange}
        />
      )}
    />
  );
};
